import './AppFooter.css';
import * as React from "react";

export default class AppFooter extends React.Component {
    handleNextButton = (e) => {
        e.preventDefault();
        if (!this.props.onNext) {
            console.error("No onNext action on the footer but the button exists");
            return;
        }
        if ((this.props.onPrevious ? this.props.enableNext : true) || this.props.last) {
            this.props.onNext();
        }
    }

    handlePreviousButton = (e) => {
        e.preventDefault();
        if (!this.props.onPrevious) {
            console.error("No onPrevious action on the footer but the button exists");
            return;
        }
        this.props.onPrevious()
    }

    render() {
        let next = null;
        let previous = null;
        if (this.props.onNext && !this.props.onPrevious) {
            next = (
                <button id="start-button" onClick={this.handleNextButton}><span className="button-for-blind-people">Start</span></button>
            )
        } else if (this.props.onNext && this.props.send) {
            next = (
                <button id="next-button" onClick={this.handleNextButton}>Verstuur aanvraag</button>
            )
        } else if (this.props.onNext && this.props.last) {
            next = (
                <button id="next-button" onClick={this.handleNextButton}>Opnieuw invullen</button>
            )
        } else if (this.props.onNext) {
            next = (
                <button id="next-button" onClick={this.handleNextButton} disabled={!this.props.enableNext}>Verder</button>
            )
        }

        if (this.props.onPrevious) {
            previous = (
                <button id="previous-button" onClick={this.handlePreviousButton} className="button-divider">Terug</button>
            )
        }

        return (
            <footer className="app-footer">
                {previous}
                {next}
            </footer>
        );
    }
}
